import React, { useState } from 'react';
import { all_routes } from '../../router/all_routes';
import Breadcrumb from '../../../core/common/Breadcrumb/breadcrumb';
import api from '../../../lib/axios'; // Certifique-se que este está configurado com baseURL

const AddPartner = () => {
  const routes = all_routes;

  const breadcrumbs = [
    { label: 'Dashboard', link: routes.home1, active: false },
    { label: 'Add Partner', active: true },
  ];

  // Estados dos campos do formulário
  const [companyName, setCompanyName] = useState('');
  const [email, setEmail] = useState('');
  const [nif, setNif] = useState('');
  const [address, setAddress] = useState('');
  const [postalCode, setPostalCode] = useState('');
  const [comments, setComments] = useState('');
  const [documents, setDocuments] = useState<FileList | null>(null);

  // Submit handler
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('company_name', companyName);
    formData.append('email', email);
    formData.append('nif', nif);
    formData.append('address', address);
    formData.append('postal_code', postalCode);
    formData.append('comments', comments);

    if (documents) {
      Array.from(documents).forEach((file, i) => {
        formData.append(`documents[${i}]`, file);
      });
    }

    try {
      const response = await api.post('/partners', formData); // Verifique se esta é a rota correta no backend
      alert('Parceiro cadastrado com sucesso!');
    } catch (error) {
      console.error(error);
      alert('Erro ao cadastrar parceiro');
    }
  };

  return (
    <>
      <Breadcrumb
        title="Add Partner"
        breadcrumbs={breadcrumbs}
        backgroundClass="breadcrumb-bg-02"
      />

      <div className="content">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <form className="card shadow-none" onSubmit={handleSubmit}>
                <div className="card-header">
                  <h5 className="fs-18">Partner Details</h5>
                </div>
                <div className="card-body pb-1">
                  <div className="row">
                    <div className="col-md-12 mb-3">
                      <label className="form-label">Nome da Empresa</label>
                      <input
                        type="text"
                        className="form-control"
                        value={companyName}
                        onChange={(e) => setCompanyName(e.target.value)}
                        required
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Email</label>
                      <input
                        type="email"
                        className="form-control"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">NIF</label>
                      <input
                        type="text"
                        className="form-control"
                        value={nif}
                        onChange={(e) => setNif(e.target.value)}
                      />
                    </div>
                    <div className="col-md-8 mb-3">
                      <label className="form-label">Morada</label>
                      <input
                        type="text"
                        className="form-control"
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                      />
                    </div>
                    <div className="col-md-4 mb-3">
                      <label className="form-label">Código Postal</label>
                      <input
                        type="text"
                        className="form-control"
                        value={postalCode}
                        onChange={(e) => setPostalCode(e.target.value)}
                      />
                    </div>

                    <div className="col-md-12 mb-3">
                      <label className="form-label">Comentários</label>
                      <textarea
                        className="form-control"
                        rows={4}
                        value={comments}
                        onChange={(e) => setComments(e.target.value)}
                      />
                    </div>

                    <div className="col-md-12 mb-3">
                      <label className="form-label">Documentos</label>
                      <input
                        type="file"
                        className="form-control"
                        multiple
                        onChange={(e) => setDocuments(e.target.files)}
                      />
                      <small className="text-muted d-block mt-1">Você pode enviar múltiplos arquivos PDF, DOCX ou imagens.</small>
                    </div>
                  </div>
                </div>
                <div className="card-footer text-end">
                  <button type="reset" className="btn btn-light me-2">Reset</button>
                  <button type="submit" className="btn btn-primary">Cadastrar Parceiro</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddPartner;
